export const BUTTON_VARIANT_M = 'm';
export const BUTTON_VARIANT_S = 's';
export const BUTTON_VARIANT_OUTLINE = 'outline-solid';
export const BUTTON_VARIANT_CLEAN = 'clean';
export const BUTTON_VARIANT_FILL = 'fill';
export const BUTTON_VARIANT_CTA = 'cta';
export const BUTTON_VARIANT_FILTER = 'filter';

/** `ButtonIcon`'s enabled FILL look, shared with triggers that cannot be a `ButtonIcon` themselves. */
export const BUTTON_ICON_FILL_CLASSES =
  'text-primary fill-tertiary active:fill-tertiary-active focus-visible:fill-tertiary-active cursor-pointer';
